import React from 'react';
import styles from './styles.module.scss';
import PopupModal from '@conversionProgram/src/Components/PopupModal_V2';
import Button from '@conversionProgram/src/Components/Button_V2';
import icFailure from 'assets/img/ic_error_v2.png';

const TransactionErrorModal = ({
  onClose,
  error
}) => {
  return /*#__PURE__*/React.createElement(PopupModal, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icFailure
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "OOPS!!")), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, `Error code ${error}`)), /*#__PURE__*/React.createElement("div", {
    className: styles.btnGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    title: "I got it",
    className: styles.btn
  })));
};

export default TransactionErrorModal;